export const allowedMarkers = [
	'afid',
	'fb-psid',
	'subafid',
	'afid2',
	'subid2',
	'referrer',
	'gclid',
	'offer-id',
	'goal-id',
	'clickid',
	'transaction-id',
	'transaction_id',
	'country',
	'tracker',
	'utm_source',
	'utm_medium',
	'utm_campaign',
	'utm_term',
	'utm_content',
	'smart-landing',
	'fbclid',
	'k_id',
	'_fbp',
	'_fbc',
];
